import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class AfterPlayerCareerPlanedEndEvent extends AbstractEvent {
  constructor(
    public player: Player,
  ) {
    super();
  }
}